<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
      style="margin-right: 10px; width: 200px; margin-top: 10px"
        v-model="search.user_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入所属用户"
        :remote-method="searchRemoteMethod"
        :loading="userLoading"
      >
        <el-option
          v-for="item in searchUserList"
          :key="item.id"
          :label="item.name + '-' + item.phone"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-input
        style="margin-right: 10px; width: 200px; margin-top: 10px"
        v-model="search.coupon_no"
        placeholder="请输入优惠券编号"
      ></el-input>
      <el-input
        style="margin-right: 10px; width: 200px; margin-top: 10px"
        v-model="search.car_number"
        placeholder="请输入下发车牌号"
      ></el-input>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="search.type"
        placeholder="请选择优惠券类型"
      >
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in typeList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="search.status"
        placeholder="请选择发放状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="未下发" :value="1"></el-option>
        <el-option label="已下发" :value="2"></el-option>
      </el-select>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="search.is_discount"
        placeholder="请选择抵扣状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="未抵扣" :value="1"></el-option>
        <el-option label="已抵扣" :value="2"></el-option>
      </el-select>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="search.is_invalid"
        placeholder="请选择作废状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="有效" :value="1"></el-option>
        <el-option label="作废" :value="2"></el-option>
      </el-select>
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px; margin-top: 10px"
        >重置</el-button
      >
      <el-button
        type="primary"
        @click="(search.page = 1), fetchData()"
        style="margin-bottom: 5px; margin-top: 10px"
        >搜索</el-button
      >
    </div>
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-top: 5px"
      v-if="roles.includes('/carport/add_coupons')"
      >添加</el-button
    >

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (search.page - 1) * search.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="优惠券编号" min-width="210">
        <template slot-scope="scope">
          <span> {{ scope.row.coupon_no ? scope.row.coupon_no : "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="下发车牌" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.car_number ? scope.row.car_number : "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="企业" width="150">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.company ? scope.row.company.name : "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属用户" width="150">
        <template slot-scope="scope">
          <div class="line2">
            {{
              scope.row.user
                ? scope.row.user.name + "-" + scope.row.user.phone
                : ""
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="优惠券类型" width="110">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 1
              ? "减免券"
              : scope.row.type == 2
              ? "折扣券"
              : scope.row.type == 4
              ? "减时券"
              : "全免券"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="抵扣" width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1"
            >{{ scope.row.tpl_json ? scope.row.tpl_json.value : "--" }}元</span
          >
          <span v-if="scope.row.type == 2"
            >{{ scope.row.tpl_json ? scope.row.tpl_json.value : "--" }}折</span
          >
          <span v-if="scope.row.type == 4"
            >{{ scope.row.tpl_json ? scope.row.tpl_json.value : "--" }}分</span
          >
          <span v-if="scope.row.type == 3">全免</span>
        </template>
      </el-table-column>
      <el-table-column label="优惠券有效截止时间" width="200">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.end_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="抵扣状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_discount == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.is_discount == 1 ? "未抵扣" : "已抵扣" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="抵扣时间" width="200">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.discount_time || "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下发状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "未下发" : "已下发" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="下发时间" width="200">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.used_time || "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="作废状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_invalid == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.is_invalid == 1 ? "有效" : "作废" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="作废时间" width="200">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.invalid_time || "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/carport/coupons_info')"
            >查看</el-button
          > -->
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="
              roles.includes('/carport/coupons_invalid') &&
              scope.row.is_invalid != 2
            "
            >作废</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="search.page"
      :page-sizes="[15, 30, 50]"
      :page-size="search.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="160px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择发放人" prop="user_id">
          <!-- <el-select
            filterable
            v-model="ruleForm.user_id"
            placeholder="请选择发放人"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in userList"
              :key="index"
            ></el-option>
          </el-select> -->
          <el-select
            v-model="ruleForm.user_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入用户姓名"
            :remote-method="remoteMethod"
            :loading="userLoading"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name + '-' + item.phone"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择优惠券模板" prop="tpl_id">
          <el-select
            filterable
            v-model="ruleForm.tpl_id"
            placeholder="请选择优惠券模板"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in templateLists"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券数量" prop="number">
          <el-input
            class="w4 numInput"
            type="number "
            min="0"
            :disabled="cztype == 'see'"
            v-model="ruleForm.number"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <!-- <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit' || cztype == 'see'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button> -->
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark, openCompany, openAgoUser } from "@/api/index";
import {
  add_coupons,
  coupons_list,
  coupons_invalid,
  coupons_info,
} from "@/api/parking";
import { getToken } from "@/utils/auth";
import { get_carport_coupon_tpl_lists } from "@/api/common";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      format: "yyyy-MM-dd HH:mm:ss",
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      search: {
        page: 1,
        page_size: 15,
        status: null,
        coupon_no: "",
        car_number: "",
        type: null,
        is_invalid: null,
        is_discount: null,
        user_id: "",
      },
      // 优惠券类型
      typeList: [
        {
          title: "全部",
          id: null,
        },
        {
          title: "减免券",
          id: 1,
        },
        {
          title: "折扣券",
          id: 2,
        },
        {
          title: "全免券",
          id: 3,
        },
        {
          title: "减时券",
          id: 4,
        },
      ],
      userLoading: false,
      userList: [],
      total: 0,
      ruleForm: {},
      rules: {
        user_id: [
          { required: true, message: "请选择发放对象", trigger: "change" },
        ],
        tpl_id: [
          { required: true, message: "请选择优惠券模板", trigger: "change" },
        ],
        number: [
          { required: true, message: "请输入优惠券数量", trigger: "blur" },
        ],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      searchUserList: [],
      templateLists: [], //优惠券模板列表
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.search.park_id = this.userInfo.park_id;
    } else {
      this.search.park_id = "";
    }
    this.fetchData();
    this.getTemplate();
  },
  methods: {
    // 搜索时用户选择
    searchRemoteMethod(query) {
      if (query !== "") {
        this.userLoading = true;
        var data = {
          name: query,
          is_page: 2,
        };
        openAgoUser(data).then((response) => {
          this.userLoading = false;
          this.searchUserList = response.data.lists;
        });
      } else {
        this.searchUserList = [];
      }
    },
    // 添加时用户选择
    remoteMethod(query) {
      if (query !== "") {
        this.userLoading = true;
        var data = {
          name: query,
          is_page: 2,
        };
        openAgoUser(data).then((response) => {
          this.userLoading = false;
          this.userList = response.data.lists;
        });
      } else {
        this.userList = [];
      }
    },
    // 获取优惠券模板列表
    getTemplate() {
      get_carport_coupon_tpl_lists({ is_page: 2 }).then((res) => {
        console.log(res.data);
        this.templateLists = res.data.lists;
        console.log(this.templateLists);
      });
    },

    reset() {
      this.search = {
        page: 1,
        page_size: 15,
        status: null,
        coupon_no: "",
        car_number: "",
        type: null,
        is_invalid: null,
        is_discount: null,
        user_id: "",
      };
      this.fetchData();
    },
    handleSizeChange(val) {
      this.search.page_size = val;
      this.search.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              this.ruleForm.carLane = this.ruleForm.carLanes.join();
              carportEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleInfo(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      coupons_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          title: res.data.info.title,
          type: res.data.info.type,
          price: res.data.info.price ? Number(res.data.info.price) : 0,
          sort: res.data.info.sort,
          carLanes: res.data.info.carLane
            ? res.data.info.carLane.split(",")
            : [],
        };
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          coupons_invalid({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      console.log(this.ruleForm, "提交的数据");
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              add_coupons(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        user_id: "",
        tpl_id: "",
        number: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      coupons_list(this.search).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
</style>
